import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { GlobalLoaderService } from './global-loader.service';
import { SharedUtilsService } from './shared-utils.service';

@Injectable({ providedIn: 'root' })
export class PwaService {
  private _swUpdate = inject(SwUpdate);
  private _sharedUtilsService = inject(SharedUtilsService);
  private _globalLoaderService = inject(GlobalLoaderService);
  private _destroyRef = inject(DestroyRef);

  initPwaUpdates() {
    if (this._swUpdate.isEnabled) {
      // Subscribe to update events
      this._swUpdate.versionUpdates
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe((evt: VersionEvent) => {
          switch (evt.type) {
            case 'VERSION_DETECTED':
              console.log(`Dostępna jest nowa wersja aplikacji: ${evt.version.hash.slice(0, 6)}`);
              break;
            case 'VERSION_READY':
              this._globalLoaderService.show('Aktualizacja aplikacji...');
              setTimeout(() => window.location.reload(), 3000);
              break;
            case 'VERSION_INSTALLATION_FAILED':
              this.handleVersionInstallationFailed();
              break;
          }
        });

      // 1. Check for update on app resume (visibility change)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this._checkUpdate();
        }
      });

      // 2. Periodic check (every 6 hours)
      const sixHours = 6 * 60 * 60 * 1000;
      setInterval(() => this._checkUpdate(), sixHours);
    }
  }

  private _checkUpdate() {
    this._swUpdate.checkForUpdate().catch((err) => {
      console.error('Błąd podczas sprawdzania aktualizacji PWA:', err);
    });
  }

  private handleVersionInstallationFailed() {
    // 1. Pobieramy wszystkie rejestracje SW
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      // 2. Wyrejestrowujemy wszystkie i zbieramy ich Promise
      const unregisterPromises = registrations.map((r) => r.unregister());

      // 3. Czyścimy wszystkie cache i zbieramy ich Promise
      const cacheDeletePromises = caches
        .keys()
        .then((keys) => Promise.all(keys.map((k) => caches.delete(k))));

      // 4. Dopiero gdy WSZYSTKO zostanie wyczyszczone, robimy reload
      Promise.all([Promise.all(unregisterPromises), cacheDeletePromises])
        .then(() => {
          console.log('PWA wyczyszczone pomyślnie. Odświeżam...');
          window.location.reload();
        })
        .catch(() => {
          // Na wszelki wypadek, gdyby coś poszło nie tak, i tak odświeżamy
          window.location.reload();
        });
    });
  }
}
